var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "customer-operation-modal",
            size: "lg",
            "hide-footer": "",
            title: _vm.$t("insert.loyalty.customerBulkOperations")
          }
        },
        [
          _c("MultipleCustomerOperations", {
            model: {
              value: _vm.customers,
              callback: function($$v) {
                _vm.customers = $$v
              },
              expression: "customers"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "Loyalty" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    { attrs: { "item-key": "Code", error: _vm.$v.form.Code } },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.datePassed || _vm.isSaveAs
                        },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Description1",
                        error: _vm.$v.form.Description1
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: { type: "text" },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "StatusId",
                        error: _vm.$v.form.StatusId
                      }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: { type: "number", toggle: "" },
                        model: {
                          value: _vm.form.StatusId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "StatusId", $$v)
                          },
                          expression: "form.StatusId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            {
              model: {
                value: _vm.activeTabIndex,
                callback: function($$v) {
                  _vm.activeTabIndex = $$v
                },
                expression: "activeTabIndex"
              }
            },
            [
              _c(
                "b-tab",
                {
                  attrs: { title: _vm.$t("insert.loyalty.title"), active: "" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.tabValidation()
                    }
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "Genexp1",
                            error: _vm.$v.form.Genexp1
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text", disabled: _vm.datePassed },
                            model: {
                              value: _vm.form.Genexp1,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "Genexp1", $$v)
                              },
                              expression: "form.Genexp1"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CustomerCriteriaId",
                            error: _vm.$v.form.CustomerCriteriaId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.datePassed,
                              "lookup-key": "CUSTOMER_CRITERIA"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "CustomerCriteriaId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.customerCriteria,
                              callback: function($$v) {
                                _vm.customerCriteria = $$v
                              },
                              expression: "customerCriteria"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "BranchCriteriaId",
                            error: _vm.$v.form.BranchCriteriaId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.datePassed,
                              "lookup-key": "BRANCH_CRITERIA"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "BranchCriteriaId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.branchCriteria,
                              callback: function($$v) {
                                _vm.branchCriteria = $$v
                              },
                              expression: "branchCriteria"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ApplicationTypeId",
                            error: _vm.$v.form.ApplicationTypeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.datePassed,
                              "lookup-key": "LOYALTY_APPLICATION_TYPE"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "ApplicationTypeId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.applicationType,
                              callback: function($$v) {
                                _vm.applicationType = $$v
                              },
                              expression: "applicationType"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "GroupId",
                            error: _vm.$v.form.GroupId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.datePassed,
                              "lookup-key": "LOYALTY_GROUP"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("GroupId", $event)
                              }
                            },
                            model: {
                              value: _vm.group,
                              callback: function($$v) {
                                _vm.group = $$v
                              },
                              expression: "group"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "TypeId",
                            error: _vm.$v.form.TypeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.datePassed,
                              "lookup-key": "LOYALTY_TYPE"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("TypeId", $event)
                              }
                            },
                            model: {
                              value: _vm.type,
                              callback: function($$v) {
                                _vm.type = $$v
                              },
                              expression: "type"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "LoyaltyBeginDate",
                            error: _vm.$v.form.LoyaltyBeginDate
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: { disabled: _vm.datePassed },
                            model: {
                              value: _vm.form.LoyaltyBeginDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "LoyaltyBeginDate", $$v)
                              },
                              expression: "form.LoyaltyBeginDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "LoyaltyEndDate",
                            error: _vm.$v.form.LoyaltyEndDate
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            model: {
                              value: _vm.form.LoyaltyEndDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "LoyaltyEndDate", $$v)
                              },
                              expression: "form.LoyaltyEndDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "FinanceCode",
                            error: _vm.$v.form.FinanceCode
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text", disabled: _vm.datePassed },
                            model: {
                              value: _vm.form.FinanceCode,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "FinanceCode", $$v)
                              },
                              expression: "form.FinanceCode"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "TCIBreak1Id",
                            error: _vm.$v.form.TCIBreak1Id
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.datePassed,
                              "lookup-key": "TCI_BREAKDOWN"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("TCIBreak1Id", $event)
                              }
                            },
                            model: {
                              value: _vm.tciBreak1,
                              callback: function($$v) {
                                _vm.tciBreak1 = $$v
                              },
                              expression: "tciBreak1"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ClassId",
                            error: _vm.$v.form.ClassId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.ClassId,
                              "lookup-key": "LOYALTY_CLASS"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("ClassId", $event)
                              }
                            },
                            model: {
                              value: _vm.selectedClass,
                              callback: function($$v) {
                                _vm.selectedClass = $$v
                              },
                              expression: "selectedClass"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "KindId",
                            error: _vm.$v.form.KindId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.KindId,
                              "lookup-key": "LOYALTY_KIND"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("KindId", $event)
                              }
                            },
                            model: {
                              value: _vm.selectedKind,
                              callback: function($$v) {
                                _vm.selectedKind = $$v
                              },
                              expression: "selectedKind"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.showDetails
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.loyalty.loyaltyCatalogue")
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: { items: _vm.loyaltyCatalogueItems },
                        model: {
                          value: _vm.form.LoyaltyCatalogues,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "LoyaltyCatalogues", $$v)
                          },
                          expression: "form.LoyaltyCatalogues"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: { title: _vm.$t("insert.loyalty.pointCriterias") },
                  on: { click: _vm.setDatePlanType }
                },
                [
                  !_vm.datePassed
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "insert.loyalty.categoryDefinition"
                                ),
                                error:
                                  _vm.$v.loyaltyActiveCategory.loyaltyCategory,
                                required: true
                              }
                            },
                            [
                              _c("NextDropdown", {
                                attrs: {
                                  url:
                                    "VisionNextLoyalty/api/LoyaltyCategory/Search"
                                },
                                model: {
                                  value:
                                    _vm.loyaltyActiveCategory.loyaltyCategory,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.loyaltyActiveCategory,
                                      "loyaltyCategory",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "loyaltyActiveCategory.loyaltyCategory"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                title: _vm.$t("insert.loyalty.datePlanType"),
                                error:
                                  _vm.$v.loyaltyActiveCategory.datePlanType,
                                required: true
                              }
                            },
                            [
                              _c("NextDropdown", {
                                attrs: {
                                  disabled: _vm.disabledDatePlanType,
                                  "lookup-key": "DATE_PLAN_TYPE",
                                  "get-lookup": ""
                                },
                                on: { input: _vm.selectDatePlanType },
                                model: {
                                  value: _vm.loyaltyActiveCategory.datePlanType,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.loyaltyActiveCategory,
                                      "datePlanType",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "loyaltyActiveCategory.datePlanType"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                title: _vm.$t("insert.loyalty.datePlanFreq"),
                                error:
                                  _vm.$v.loyaltyActiveCategory.datePlanFreq,
                                required:
                                  _vm.loyaltyActiveCategory.datePlanType &&
                                  _vm.loyaltyActiveCategory.datePlanType
                                    .Code !== "ST"
                              }
                            },
                            [
                              _c("NextInput", {
                                attrs: {
                                  type: "number",
                                  disabled:
                                    _vm.loyaltyActiveCategory.datePlanType &&
                                    _vm.loyaltyActiveCategory.datePlanType
                                      .Code === "ST"
                                },
                                model: {
                                  value: _vm.loyaltyActiveCategory.datePlanFreq,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.loyaltyActiveCategory,
                                      "datePlanFreq",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "loyaltyActiveCategory.datePlanFreq"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "insert.loyalty.customerCriteria"
                                ),
                                error:
                                  _vm.$v.loyaltyActiveCategory.customerCriteria,
                                required: true
                              }
                            },
                            [
                              _c("NextDropdown", {
                                attrs: {
                                  source: _vm.lookup.CUSTOMER_CRITERIA
                                    ? _vm.lookup.CUSTOMER_CRITERIA.filter(
                                        function(c) {
                                          return c.Code !== "ML"
                                        }
                                      )
                                    : [],
                                  label: "Label"
                                },
                                model: {
                                  value:
                                    _vm.loyaltyActiveCategory.customerCriteria,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.loyaltyActiveCategory,
                                      "customerCriteria",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "loyaltyActiveCategory.customerCriteria"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                title: _vm.$t("insert.loyalty.description"),
                                error: _vm.$v.loyaltyActiveCategory.description,
                                required: true
                              }
                            },
                            [
                              _c("NextInput", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.loyaltyActiveCategory.description,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.loyaltyActiveCategory,
                                      "description",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "loyaltyActiveCategory.description"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "text-right",
                              attrs: { cols: "12", md: "2" }
                            },
                            [
                              _c(
                                "b-form-group",
                                [
                                  _c("AddDetailButton", {
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.addLoyaltyActiveCategory(
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-table", {
                        attrs: {
                          fields: _vm.loyaltyActiveCategoryFields,
                          items: this.form.LoyaltyActiveCategories
                            ? this.form.LoyaltyActiveCategories.filter(function(
                                i
                              ) {
                                return i.RecordState !== 4
                              })
                            : [],
                          bordered: "",
                          responsive: ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "head()",
                            fn: function(data) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t(data.label)) +
                                    "\n            "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(operations)",
                            fn: function(row) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "text-center" },
                                  [
                                    !_vm.datePassed
                                      ? _c(
                                          "b-button",
                                          {
                                            staticClass: "mr-2",
                                            attrs: {
                                              size: "sm",
                                              variant: "danger"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.removeLoyaltyActiveCategory(
                                                  row.item
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "far fa-trash-alt"
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "insert.loyalty.delete"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    (row.item.CustomerCriteria &&
                                      row.item.CustomerCriteria.Code !==
                                        "TM") ||
                                    row.item.CustomerCriteriaIdCode !== "TM" ||
                                    (row.item.DatePlanType &&
                                      row.item.DatePlanType.Code === "ST") ||
                                    row.item.DatePlanTypeIdCode === "ST"
                                      ? _c(
                                          "b-button",
                                          {
                                            staticClass: "mr-2",
                                            attrs: {
                                              size: "sm",
                                              variant: "success"
                                            },
                                            on: { click: row.toggleDetails }
                                          },
                                          [
                                            _c("i", {
                                              class: row.detailsShowing
                                                ? "fa fa-arrow-up"
                                                : "fa fa-arrow-down"
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "insert.loyalty.details"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            }
                          },
                          {
                            key: "row-details",
                            fn: function(ref) {
                              var item = ref.item
                              var index = ref.index
                              return [
                                (item.CustomerCriteria &&
                                  item.CustomerCriteria.Code === "MK") ||
                                item.CustomerCriteriaIdCode === "MK"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "p-4 mt-2 nested-detail-panel"
                                      },
                                      [
                                        _c("h3", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.loyalty.customerCriteria"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("NextDetailPanel", {
                                          attrs: {
                                            type: "get",
                                            items: _vm.loyaltyActiveCtCritItems
                                          },
                                          model: {
                                            value:
                                              _vm.form.LoyaltyActiveCategories[
                                                index
                                              ].LoyaltyActiveCtCrits,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form
                                                  .LoyaltyActiveCategories[
                                                  index
                                                ],
                                                "LoyaltyActiveCtCrits",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.LoyaltyActiveCategories[index].LoyaltyActiveCtCrits"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                (item.CustomerCriteria &&
                                  item.CustomerCriteria.Code === "MS") ||
                                item.CustomerCriteriaIdCode === "MS"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "p-4 mt-2 nested-detail-panel"
                                      },
                                      [
                                        _c("h3", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.loyalty.customerQuery"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("NextDetailPanel", {
                                          attrs: {
                                            type: "get",
                                            items: _vm.loyaltyActiveCtSqlItems
                                          },
                                          model: {
                                            value:
                                              _vm.form.LoyaltyActiveCategories[
                                                index
                                              ].LoyaltyActiveCtSqls,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form
                                                  .LoyaltyActiveCategories[
                                                  index
                                                ],
                                                "LoyaltyActiveCtSqls",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.LoyaltyActiveCategories[index].LoyaltyActiveCtSqls"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                (item.DatePlanType &&
                                  item.DatePlanType.Code === "ST") ||
                                item.DatePlanTypeIdCode === "ST"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "p-4 mt-2 nested-detail-panel"
                                      },
                                      [
                                        _c("h3", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.loyalty.constantDates"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("NextDetailPanel", {
                                          attrs: {
                                            type: "get",
                                            items: _vm.loyaltyActiveCtDateItems
                                          },
                                          model: {
                                            value:
                                              _vm.form.LoyaltyActiveCategories[
                                                index
                                              ].LoyaltyActiveCtDates,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form
                                                  .LoyaltyActiveCategories[
                                                  index
                                                ],
                                                "LoyaltyActiveCtDates",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.LoyaltyActiveCategories[index].LoyaltyActiveCtDates"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.branchCriteria && _vm.branchCriteria.Code === "SL"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.loyalty.branchs")
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: { items: _vm.loyaltyBranchItems },
                        model: {
                          value: _vm.branchs,
                          callback: function($$v) {
                            _vm.branchs = $$v
                          },
                          expression: "branchs"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.customerCriteria && _vm.customerCriteria.Code === "ML"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.loyalty.customers")
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.customersTabClicked($event)
                        }
                      }
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "12" } },
                            [
                              _c(
                                "b-form-group",
                                { staticClass: "text-right" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "b-modal",
                                          rawName:
                                            "v-b-modal.customer-operation-modal",
                                          modifiers: {
                                            "customer-operation-modal": true
                                          }
                                        }
                                      ],
                                      staticClass: "mt-1",
                                      attrs: { size: "sm", variant: "success" }
                                    },
                                    [
                                      _c("i", { staticClass: "fa fa-list" }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "insert.loyalty.customerBulkOperations"
                                            )
                                          )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("NextDetailPanel", {
                        attrs: { items: _vm.getLoyaltyCustomerItems() },
                        model: {
                          value: _vm.customers,
                          callback: function($$v) {
                            _vm.customers = $$v
                          },
                          expression: "customers"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.customerCriteria && _vm.customerCriteria.Code === "MK"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.loyalty.customerCriterias")
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: { items: _vm.loyaltyCustomerCriteriaItems },
                        model: {
                          value: _vm.customerCriterias,
                          callback: function($$v) {
                            _vm.customerCriterias = $$v
                          },
                          expression: "customerCriterias"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.customerCriteria && _vm.customerCriteria.Code === "MS"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.loyalty.customerQuery")
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: { items: _vm.loyaltyCustomerSqlItems },
                        model: {
                          value: _vm.form.LoyaltyCustomerSqls,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "LoyaltyCustomerSqls", $$v)
                          },
                          expression: "form.LoyaltyCustomerSqls"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-99855d54", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99855d54","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Loyalty/update.vue
// module id = null
// module chunks = 